<template>
  <div class="f12">
    <div class="bg063069 informationTop cfff dCC">
      <p class="f24">公告</p>
    </div>

    <div class="main_width m0a pt25 pb30">
      <div class="fSpace">
        <div class="w947 p20 pb0 bgfff bs31 mr15 tl" style="height: fit-content;">
          <router-view />
        </div>

        <div>
          <div class="cp mb25" @click="toLinkUrl(img1.linkUrl)" v-if="img1.linkUrl">
            <img :src="getImgUrl(img1.picName)" height="343" width="228" alt="">
          </div>
          <div class="mb25" v-else>
            <img :src="getImgUrl(img1.picName)" height="343" width="228" alt="">
          </div>

          <div class="cp" @click="toLinkUrl(img2.linkUrl)" v-if="img2.linkUrl">
            <img :src="getImgUrl(img2.picName)" height="343" width="228" alt="">
          </div>
          <div v-else>
            <img :src="getImgUrl(img2.picName)" height="343" width="228" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      img1: '',
      img2: '',
    }
  },
  created () {
    // 快贴宝资讯广告图1
    this.getAdvertimg('ktb_notice_1', (data) => {
      this.img1 = data
    });

    // 快贴宝资讯广告图2
    this.getAdvertimg('ktb_notice_2', (data) => {
      this.img2 = data
    });
  }
}
</script>

<style>
.informationTop {
  height: 128px;
  background: url('~@/assets/img/information/bj@2x.png') no-repeat center center;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/Notice.vue